module.exports = __webpack_public_path__ + "img/27@2x.3b15fca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/27@2x.png
// module id = 3WcY
// module chunks = 0